export default __webpack_public_path__ + "static/verde-22f2fc312066a27b540431bd0129e409.png";